<template>
    <div>
        <div class="header_unit header_bg_blue" v-if="!reInputFlg">
            <div class="header_box">
                <div class="menu_left">
                    <router-link :to="{ name: 'cookingCheckIndex', params: { menuId: menuId, brandPath: brandPath}} ">キャンセル</router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_s">{{upperButtonName}}</p>
                    <p class="menu_center_tex_l">{{lowerButtonName}}</p>
                </div>
                <div class="menu_right">
                    <a role="button" @click.prevent.stop="openModel(dailyCheckMenuList.manualFilePath,modal_type.manual)"><i class="far fa-question-circle"></i> マニュアル</a>
                </div>
            </div>
        </div>

        <div class="header_unit header_bg_red" v-if="reInputFlg">
            <div class="header_box">
                <div class="menu_left">
                    <router-link :to="{ name: 'cookingCheckInput' ,params: { menuId: menuId, subMenuId: subMenuId, brandPath: brandPath}} ">キャンセル</router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_s">{{upperButtonName}}</p>
                    <p class="menu_center_tex_l">【再計測】{{lowerButtonName}}</p>
                </div>
                <div class="menu_right">
                    <a  role="button" @click.prevent.stop="openModel(dailyCheckMenuList.manualFilePath,modal_type.manual)"><i class="far fa-question-circle"></i> マニュアル</a>
                </div>
            </div>
        </div>
        <div class="main_unit">
            <div class="top_unit">
                <div class="top_name_box">
                  <select id="historyFilter"  v-model="getStaffId">
                    <option v-for="staff in staffList" :key="staff['id']" :value="staff['id']">{{staff['staffName']}}</option>
                  </select>
                </div>
                <div class="top_center_box"> </div>
            </div>

            <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
            <div v-show="!isInitLoading">
                <div class="btn_link_tyori_setting_unit">
                  <div class="btn_link_tyori_setting_box">
                    <router-link :to="{ name: 'manageStoreTyoriSetting', params: {menuId:menuId,subMenuId:subMenuId}}">
                      当日追加メニュー登録</router-link>
                  </div>
                </div>
                <div v-if="validationMessage">
                  <Message :validationMessage="alertMessage" /><br>
                  <Message :validationMessage="validationMessage" />
                </div>
                <div class="check_tyori_tbl_unit tbl_bg_blue mgt_15" style="max-height: 700px;display: flex;">

                    <div>
                        <div class="all_ok_unit" >
                          <div class="all_ok_head" v-bind:style="headerStyle">すべて〇</div>
                          <div v-for="(Item, allOkIndex) in filterItems" :key="Item.indexLng">
                            <div :id=allOkIndex class="all_ok_area" v-bind:style="boxStyle">
                              <a href="#" role="button" class="all_ok_box" v-if="Item.allCheckFlg==='0'" @click.prevent.stop="clickAllCheck(Item.indexLng)"></a>
                              <a href="#" role="button" class="all_ok_box" v-if="Item.allCheckFlg==='1'" @click.prevent.stop="clickAllCheck(Item.indexLng)">
                                <p class="icn_blue_ss"><i class="fas fa-check"></i></p>
                              </a>
                              <a href="#" role="button" class="all_ok_box_disabled" v-if="Item.allCheckFlg==='2'"></a>
                            </div>
                          </div>
                        </div>
                    </div>
                    <div>
                      <table class="check_tyori_tbl_unit_table_contents">
                        <tbody v-if="rowspan == 1" ref="tbody" class="cooking_setting_sticky_top z_3">
                          <tr >
                              <th class="wd240 checkSetting_text_align cooking_check_sticky z_3" style="max-width: 240px;white-space: normal;left:0;">調理名</th>
                              <th class="wd120_fix_min cooking_check_sticky z_3" colspan="2" style="text-align: center;left:240px">加熱後温度</th>
                              <th v-if="cookingCheckButtonNo == 5" class="wd120_fix_min cooking_check_sticky z_3" colspan="2" style="text-align: center;left:360px">再加熱後温度</th>
                              <th class="wd90" >履歴</th>
                              <th v-if="isExitsGroup" class="wd240 checkSetting_text_align" >グループ</th>
                              <th rowspan="2" class="wd90 tbl_tex_center text_white_space" v-for="HeaderList in headerFilter1" :key="'hdInfo_' +HeaderList.cookingCheckHeaderNo" :id="HeaderList.cookingCheckHeaderNo">
                                {{HeaderList.lowerHeaderName}}
                              </th>

                              <th rowspan="2"  class="checkSetting_text_align">改善措置／コメント
                                <a role="button" @click.prevent.stop="openModel(dailyCheckMenuList.informationFilePath,modal_type.info)"><i class="fas fa-info-circle info_icn_red"></i></a>
                              </th>

                          </tr>
                          <tr >
                              <th class="wd240 checkSetting_text_align cooking_check_sticky z_3" style="max-width: 240px;white-space: normal;left:0;">
                                <input class="modal_text_field" type="text" v-model="searchWord" placeholder="調理名検索">
                              </th>
                              <th class="text_white_space cooking_check_sticky z_3 wd60" style="text-align: center;left:240px;">下限</th>
                              <th class="text_white_space cooking_check_sticky z_3 wd60" style="text-align: center;left:300px;">上限</th>
                              <th v-if="cookingCheckButtonNo == 5" class="text_white_space cooking_check_sticky z_3 wd60" style="text-align: center;left:360px;">下限</th>
                              <th v-if="cookingCheckButtonNo == 5" class="text_white_space cooking_check_sticky z_3 wd60" style="text-align: center;left:420px;">上限</th>

                              <th class="border_top_none alertList_text_align">
                                <select id="historyFilter"  v-model="selectFilterFlg">
                                  <option v-for="historyFlg in historyFilter" :key="historyFlg['id']" :value="historyFlg['id']">{{historyFlg['name']}}</option>
                                </select>
                              </th>
                              <th v-if="isExitsGroup" class="border_top_none alertList_text_align">
                                <select id="selectGroup"  v-model="selectGroupWord">
                                  <option value="">全て</option>
                                  <option v-for="group in cookingNameGroup" :key="group['id']" :value="group['groupName']">{{group['groupName']}}</option>
                                </select>
                              </th>
                          </tr>

                          </tbody>
                          <tbody v-if="rowspan == 2" ref="tbody" class="cooking_setting_sticky_top z_3">
                          <tr >
                              <th class="wd240 checkSetting_text_align cooking_check_sticky z_3" style="max-width: 240px;white-space: normal;left:0;">調理名</th>
                              <th class="wd120_fix_min cooking_check_sticky z_3" colspan="2" style="text-align: center;left:240px">加熱後温度</th>
                              <th v-if="cookingCheckButtonNo == 5" class="wd120_fix_min cooking_check_sticky z_3" colspan="2" style="text-align: center;left:360px">再加熱後温度</th>
                              <th class="wd90" >履歴</th>
                              <th v-if="isExitsGroup" class="wd240 checkSetting_text_align" >グループ</th>
                              <th class="tbl_tex_center text_white_space wd90" v-if="dailyCheckMenuList.cookingHeaderList[0].inputType == 6 && dailyCheckMenuList.cookingHeaderList[0].displayFlg == 1"
                                  rowspan="2">{{dailyCheckMenuList.cookingHeaderList[0].lowerHeaderName}}</th>
                              <th class="tbl_tex_center text_white_space" v-if="hedderUpname1 !== '' && hedderUpname1 !== null" :colspan="hedderList1">{{hedderUpname1}}</th>
                              <th class="tbl_tex_center text_white_space" v-if="hedderUpname2 !== '' && hedderUpname2 !== null" :colspan="hedderList2">{{hedderUpname2}}</th>
                              <th class="tbl_tex_center text_white_space" v-if="hedderUpname3 !== '' && hedderUpname3 !== null" :colspan="hedderList3">{{hedderUpname3}}</th>
                              <th class="tbl_tex_center text_white_space" v-if="hedderUpname4 !== '' && hedderUpname4 !== null" :colspan="hedderList4">{{hedderUpname4}}</th>
                              <th rowspan="2" class="wd90 tbl_tex_center text_white_space" v-for="HeaderList in headerFilter3" :key="'hdInfo_' +HeaderList.cookingCheckHeaderNo" :id="HeaderList.cookingCheckHeaderNo">
                                {{HeaderList.lowerHeaderName}}
                              </th>
                              <th rowspan="2"  class="checkSetting_text_align">改善措置／コメント
                                <a role="button" @click.prevent.stop="openModel(dailyCheckMenuList.informationFilePath,modal_type.info)"><i class="fas fa-info-circle info_icn_red"></i></a>
                              </th>

                          </tr>
                          <tr >
                            <th class="wd240 checkSetting_text_align cooking_check_sticky z_3" style="max-width: 240px;white-space: normal;left:0;">
                              <input class="modal_text_field" type="text" v-model="searchWord" placeholder="調理名検索">
                            </th>
                            <th class="text_white_space cooking_check_sticky z_3 wd60" style="text-align: center;left:240px;">下限</th>
                            <th class="text_white_space cooking_check_sticky z_3 wd60" style="text-align: center;left:300px;">上限</th>
                            <th v-if="cookingCheckButtonNo == 5" class="text_white_space cooking_check_sticky z_3 wd60" style="text-align: center;left:360px;">下限</th>
                            <th v-if="cookingCheckButtonNo == 5" class="text_white_space cooking_check_sticky z_3 wd60" style="text-align: center;left:420px;">上限</th>
                            <th class="border_top_none alertList_text_align">
                              <select id="historyFilter"  v-model="selectFilterFlg">
                                <option v-for="historyFlg in historyFilter" :key="historyFlg['id']" :value="historyFlg['id']">{{historyFlg['name']}}</option>
                              </select>
                            </th>
                            <th v-if="isExitsGroup" class="border_top_none alertList_text_align">
                              <select id="selectGroup"  v-model="selectGroupWord">
                                <option value="">全て</option>
                                <option v-for="group in cookingNameGroup" :key="group['id']" :value="group['groupName']">{{group['groupName']}}</option>
                              </select>
                            </th>
                            <th class="wd90 tbl_tex_center text_white_space" v-for="HeaderList in headerFilter1" :key="'hdInfo_' +HeaderList.cookingCheckHeaderNo" :id="HeaderList.cookingCheckHeaderNo">
                              {{HeaderList.lowerHeaderName}}
                            </th>
                          </tr>
                        </tbody>
                        <tbody id="tdHeight">
                          <tr  v-for="(Item,indexCount) in filterItems" :key="Item.indexLng">
                              <td class="cooking_background-color_def cooking_check_sticky" style="max-width: 240px;white-space: normal;left:0;">
                                  <label style="font-size: 15px;color: #305d76;width:100%;text-align: left;padding: 8px;">{{Item["cookingName"]}}</label>
                              </td>
                              <td class="cooking_background-color_def cooking_check_sticky" style="left:240px;"><label style="font-size: 15px;color: #305d76;width:100%;text-align: left;padding: 8px;">{{Item["heatedLowerTemperature"]}}</label></td>
                              <td class="cooking_background-color_def cooking_check_sticky" style="left:300px;"><label style="font-size: 15px;color: #305d76;width:100%;text-align: left;padding: 8px;">{{Item["heatedUpperTemperature"]}}</label></td>
                              <td v-if="cookingCheckButtonNo == 5" class="cooking_background-color_def cooking_check_sticky" style="left:360px;"><label style="font-size: 15px;color: #305d76;width:100%;text-align: left;padding: 8px;">{{Item["reHeatedLowerTemperature"]}}</label></td>
                              <td v-if="cookingCheckButtonNo == 5" class="cooking_background-color_def cooking_check_sticky" style="left:420px;"><label style="font-size: 15px;color: #305d76;width:100%;text-align: left;padding: 8px;">{{Item["reHeatedUpperTemperature"]}}</label></td>

                              <td class="cooking_background-color_def">
                                  <router-link v-if="Item.historyFlg" :to="{name: 'cookingcommnhistoryindex' ,
                                        params:{subMenuId:subMenuId,reInputFlg:reInputFlg,cookingId:Item.cookingId}}" target='_blank' rel="noopener noreferrer">
                                    <p class="icn_blue_td" ><i class="fas fa-history"></i></p>
                                  </router-link>
                              </td>
                              <td v-if="isExitsGroup" class="cooking_background-color_def">
                                  <label style="font-size: 15px;color: #305d76;width:100%;text-align: left;padding: 8px;">{{Item["groupName"]}}</label>
                              </td>

                              <td v-for="(List,index) in headerFilter2" :key="List.cookingCheckHeaderNo"  :id="indexCount" :class="chengeClore(Item.histryData,index)">

                                  <label class="disabled" v-if="List.inputType == 6 && Item.todayInputFlg == '' &&
                                       Item['htsi_' +List.cookingCheckHeaderId] == ''"></label>
                                  <a href="#" role="button" v-if="List.inputType == 6 && Item.todayInputFlg == '' && (Item['htsi_' +List.cookingCheckHeaderId] == '1' || Item['htsi_' +List.cookingCheckHeaderId] == '2')"  @click.prevent.stop="todayCheckInput(Item.indexLng,List.cookingCheckHeaderId)">
                                      <p class="icn_white_td"><i class="far fa-check"></i></p></a>
                                  <a href="#" role="button" v-if="List.inputType == 6 && Item.todayInputFlg == '1' && (Item['htsi_' +List.cookingCheckHeaderId] == '1' || Item['htsi_' +List.cookingCheckHeaderId] == '2')"  @click.prevent.stop="todayCheckInput(Item.indexLng,List.cookingCheckHeaderId)" >
                                      <p class="icn_blue_s_td" ><i class="fas fa-check"></i></p></a>

                                  <label class="disabled " v-if="List.inputType == 4 &&  (Item['htsi_' +List.cookingCheckHeaderId] == '' || (Item.todayInputFlg == '1'
                                         && (List.cookingCheckHeaderNo == 2 || List.cookingCheckHeaderNo == 3 || List.cookingCheckHeaderNo == 4 || List.cookingCheckHeaderNo == 5 ||
                                         List.cookingCheckHeaderNo == 6 || List.cookingCheckHeaderNo == 7 )))"></label>
                                  <a href="#" role="button" @click.prevent.stop="clickCheck($event,'hd_' + List.cookingCheckHeaderId,Item.indexLng,List.cookingCheckHeaderId)" :id="'hd_' +List.cookingCheckHeaderId"
                                     v-else-if="List.inputType == 4 && (Item['htsi_' +List.cookingCheckHeaderId] === 1 && Item['hd_' + List.cookingCheckHeaderId] == '') &&
                                         (Item.todayInputFlg == '' || (List.cookingCheckHeaderNo != 2 || List.cookingCheckHeaderNo != 3 || List.cookingCheckHeaderNo !==4 || List.cookingCheckHeaderNo != 5 ||
                                         List.cookingCheckHeaderNo != 6 || List.cookingCheckHeaderNo != 7))">
                                      <p class="icn_white_td"><i class="far fa-circle"></i></p></a>
                                  <a href="#" role="button" @click.prevent.stop="clickCheck($event,'hd_' + List.cookingCheckHeaderId,Item.indexLng,List.cookingCheckHeaderId)" :id="'hd_' + List.cookingCheckHeaderId"
                                     v-else-if="List.inputType == 4 && Item['hd_' + List.cookingCheckHeaderId] == 1 &&
                                         (Item.todayInputFlg == '' || (List.cookingCheckHeaderNo != 2 || List.cookingCheckHeaderNo != 3 || List.cookingCheckHeaderNo != 4 || List.cookingCheckHeaderNo != 5 ||
                                         List.cookingCheckHeaderNo != 6 || List.cookingCheckHeaderNo != 7))">
                                      <p class="icn_blue_td"><i class="far fa-circle"></i></p></a>
                                  <a href="#" role="button" @click.prevent.stop="clickCheck($event,'hd_' + List.cookingCheckHeaderId ,Item.indexLng,List.cookingCheckHeaderId)" :id="'hd_' + List.cookingCheckHeaderId"
                                     v-else-if="List.inputType == 4 && Item['hd_' + List.cookingCheckHeaderId] == 2 &&
                                         (Item.todayInputFlg == '' || (List.cookingCheckHeaderNo != 2 || List.cookingCheckHeaderNo != 3 || List.cookingCheckHeaderNo != 4 || List.cookingCheckHeaderNo != 5 ||
                                         List.cookingCheckHeaderNo != 6 || List.cookingCheckHeaderNo != 7))">
                                      <p class="icn_red_td"><i class="fas fa-times"></i></p></a>
                                  <a href="#" role="button" @click.prevent.stop="clickCheck($event,'hd_' + List.cookingCheckHeaderId,Item.indexLng,List.cookingCheckHeaderId)" :id="'hd_' +List.cookingCheckHeaderId"
                                     v-else-if="List.inputType == 4 && (Item['htsi_' +List.cookingCheckHeaderId] === 2 && Item['hd_' + List.cookingCheckHeaderId] == '') &&
                                           (Item.todayInputFlg == '' || (List.cookingCheckHeaderNo != 2 || List.cookingCheckHeaderNo != 3 || List.cookingCheckHeaderNo !==4 || List.cookingCheckHeaderNo != 5 ||
                                           List.cookingCheckHeaderNo != 6 || List.cookingCheckHeaderNo != 7))">
                                      <p class="icn_white_td"><i class="fas fa-play" style="transform: rotate(-90deg)"></i></p></a>


                                  <label class="disabled" :id="'hd_' + List.cookingCheckHeaderId"
                                     v-if="List.inputType == 5 && (Item['htsi_' +List.cookingCheckHeaderId] == '' || (Item.todayInputFlg == '1'
                                      && (List.cookingCheckHeaderNo == 2 || List.cookingCheckHeaderNo == 3 || List.cookingCheckHeaderNo == 4 || List.cookingCheckHeaderNo == 5 ||
                                      List.cookingCheckHeaderNo == 6 || List.cookingCheckHeaderNo == 7 )))"></label>
                                  <a href="#" role="button" @click.prevent.stop="openModel2('hd_' + List.cookingCheckHeaderId,Item.indexLng,List.cookingCheckHeaderId)" :id="'hd_' + List.cookingCheckHeaderId"
                                     v-else-if="List.inputType == 5 && !inputTypeResult(Item,index) && (Item['htsi_' +List.cookingCheckHeaderId] == '1' || Item['htsi_' +List.cookingCheckHeaderId] == '2') &&
                                         (Item.todayInputFlg == '' || (List.cookingCheckHeaderNo != 2 || List.cookingCheckHeaderNo != 3 || List.cookingCheckHeaderNo != 4 || List.cookingCheckHeaderNo != 5 ||
                                         List.cookingCheckHeaderNo != 6 || List.cookingCheckHeaderNo != 7))" >選択</a>
                                  <a href="#" role="button" @click.prevent.stop="openModel2('hd_' + List.cookingCheckHeaderId,Item.indexLng,List.cookingCheckHeaderId)" :id="'hd_' + List.cookingCheckHeaderId"
                                     v-else-if="List.inputType == 5 && inputTypeResult(Item,index) && (Item['htsi_' +List.cookingCheckHeaderId] == '1' || Item['htsi_' +List.cookingCheckHeaderId] == '2') &&
                                         (Item.todayInputFlg == '' || (List.cookingCheckHeaderNo != 2 || List.cookingCheckHeaderNo != 3 || List.cookingCheckHeaderNo != 4 || List.cookingCheckHeaderNo != 5 ||
                                         List.cookingCheckHeaderNo != 6 || List.cookingCheckHeaderNo != 7))" ><p class="text_white_space_pre_wrap">{{Item.histryData[index].result_value}}</p></a>


                                  <div class="cp_ipselect cp_sl01 wd150" v-if="List.inputType == 2">
                                      <select  v-model="Item.selectedSensorId" disabled="true" v-if="Item['htsi_' +List.cookingCheckHeaderId] == '' ">
                                          <option value="" ></option>
                                      </select>
                                      <select  v-model="Item.selectedSensorId" v-else-if="(Item['htsi_' +List.cookingCheckHeaderId] == '1' || Item['htsi_' +List.cookingCheckHeaderId] == '2')" @change="cencerSelect($event,Item.indexLng,List.cookingCheckHeaderId)">
                                          <option value="" >選択</option>
                                          <option v-for="cencerList in sensorAssignmentList[Item.indexLng]" :key="cencerList.sensorId" :value="cencerList.sensorId" :id="cencerList.sensorId">
                                              {{cencerList.location}}</option>
                                      </select>
                                  </div>

                                  <label v-if="List.inputType == 1 && (Item['htsi_' +List.cookingCheckHeaderId] == '' || (Item.todayInputFlg == '1'
                                          && (List.cookingCheckHeaderNo == 2 || List.cookingCheckHeaderNo == 3 || List.cookingCheckHeaderNo == 4 || List.cookingCheckHeaderNo == 5 ||
                                          List.cookingCheckHeaderNo == 6 || List.cookingCheckHeaderNo == 7 )))"  :id="'hd_' +Item.indexLng + '' + List.inputType" />
                                  <input type="text" class="textbox_td"  :id="'hd_' +Item.indexLng + '' + List.inputType"  @change="textBoxInput($event,Item.indexLng,'hd_' +List.cookingCheckHeaderId,List.cookingCheckHeaderId)"
                                         v-if="List.inputType == 1 && (Item['htsi_' +List.cookingCheckHeaderId] == '1' || Item['htsi_' +List.cookingCheckHeaderId] == '2') &&
                                      (Item.todayInputFlg == '' || (List.cookingCheckHeaderNo != 2 || List.cookingCheckHeaderNo != 3 || List.cookingCheckHeaderNo !==4 || List.cookingCheckHeaderNo != 5 ||
                                      List.cookingCheckHeaderNo != 6 || List.cookingCheckHeaderNo != 7))" maxlength="30" v-model="Item.histryData[index].result_value">

                                  <label v-if="(List.inputType == 3 || List.inputType == 7) && (Item['htsi_' +List.cookingCheckHeaderId] == '' || (Item.todayInputFlg == '1'
                                  && (List.cookingCheckHeaderNo == 2 || List.cookingCheckHeaderNo == 3 || List.cookingCheckHeaderNo == 4 || List.cookingCheckHeaderNo == 5 ||
                                  List.cookingCheckHeaderNo == 6 || List.cookingCheckHeaderNo == 7 )))" />
                                  <vue-timepicker @close="onCloseTimePicker(Item.histryData[index].result_value, indexCount, index)" v-model="Item.histryData[index].result_value" hour-lavel="時" minute-lavel="分" v-if="(List.inputType == 3 || List.inputType == 7) && (Item['htsi_' +List.cookingCheckHeaderId] == '1' || Item['htsi_' +List.cookingCheckHeaderId] == '2') &&
                                      (Item.todayInputFlg == '' || (List.cookingCheckHeaderNo != 2 || List.cookingCheckHeaderNo != 3 || List.cookingCheckHeaderNo !==4 || List.cookingCheckHeaderNo != 5 ||
                                      List.cookingCheckHeaderNo != 6 || List.cookingCheckHeaderNo != 7))" :disabled="disabledFlg"/>

                              </td>
                              <td class="cooking_background-color_def">
                                      <textarea class="texbox_td" placeholder="コメントを入力" :value="Item.comment" :id="Item['hdte_' + Item.indexLng]"
                                                v-on:change="commnetInput($event,Item.indexLng)" maxlength="200">
                                      </textarea>
                              </td>
                          </tr>
                          </tbody>
                      </table>
                    </div>
                </div>
                <div class="btn_submit letter_spa">
                    <a href="#" role="button" @click.prevent.stop="sendCheckInput()" >送信</a>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent">
            <div >
                <div class="modal_box wd975_d">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit_s"> </p>
                            <p class="modal_header_tit" >{{ modal_title }}</p>
                        </div>
                        <div class="modal_header_left">
                            <a class="js-modal-close" role="button" @click.prevent.stop="closeModel">閉じる</a>
                        </div>
                    </div>
                    <div v-if="fileFormat=='pdf' && pages!==0" class="modal_content_tex2 image_background_color modal_content_pdf">
                        <div class="modal_content_box2">
                            <div class="pdf-container image_background_color">
                                <canvas v-for="page in pages" :id="'canvas' + page" :key="page" class="planCanvas" oncontextmenu="return false;"
                                        height="100%" width="100%" style="height: 100%; width: 100%;"></canvas>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="fileFormat=='img'" class="modal_content_tex2">
                        <div class="modal_content_box2">
                            <img class="modal_img" :src="modal_image_file_path">
                        </div>
                    </div>
                    <div v-else class="modal_content_tex2">
                        <div class="modal_content_box2">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent2">
            <div >
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit_s"> </p>
                            <p class="modal_header_tit">調理温度</p>
                        </div>
                        <div class="modal_header_left">
                            <a class="js-modal-close" role="button" @click.prevent.stop="closeModel2">閉じる</a>
                        </div>
                        <div class="modal_header_right">
                            <a class="js-modal-close" role="button" @click.prevent.stop="manualChange">手動入力</a>
                        </div>
                    </div>
                    <div class="wd460 mgt_20">
                        <div class="modal_content_tit">計測データを利用</div>
                        <div class="right_icn_redo">
                            <a href="#" role="button" v-if="selectSendSenserId !== ''" @click.prevent.stop="getSenserDataFromAWS(selectSendSenserId)"><i class="fas fa-redo"></i></a>
                        </div>
                        <div class="cp_ipselect_ondo cp_sl03 wd350 bg_blue">
                            <select v-model="selectSendSenserId" required class="bg_blue" @change="onSelectChange($event,'Load')">
                                <option value="" disabled selected>選択</option>
                                <option v-for="sensorlistData in sensorList" :key="sensorlistData.sensorId" :value="sensorlistData.sensorId">
                                    {{sensorlistData.sensorId}}:{{sensorlistData.location}}</option>
                            </select>
                        </div>
                        <div class="modal_content_box3">
                            <ul>
                                <li v-for="(senserHis,index) in getSenserData" :key="senserHis.detectionDatetime">
                                    計測時刻：{{senserHis.detectionDatetime}} 温度：{{senserHis.temperature}}℃
                                    <p class="btn_ondo" v-if="senserHis.detectionDatetime !== ''"><a role="button" @click.prevent.stop="inputSenserData(index,'Auto')">選択</a></p>
                                </li>
                            </ul>
                        </div>
                        <div class="time_now">現在の時刻：{{nowTimeStr}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent4">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit_s"> </p>
                            <p class="modal_header_tit">調理温度</p>
                        </div>
                        <div class="modal_header_left">
                            <a class="js-modal-close" role="button" @click.prevent.stop="closeModel4">閉じる</a>
                        </div>
                        <div class="modal_header_right">
                            <a class="js-modal-close" role="button" @click.prevent.stop="autoChange" >計測データ</a>
                        </div>
                    </div>
                    <div class="wd460 mgt_20">
                        <div class="modal_content_tit">手動入力</div>
                        <div class="lavel_error_font">{{validationModelMessage}}</div>
                        <div class="time_ondo_unit">
                            <div class="time_ondo_box">
                                <p class="time_ondo_tit">計測時刻</p>
                                <vue-timepicker v-model="senserInputDataMeasurementtime" @open="onOpenSensorTimePicker" @close="onCloseSensorTimePicker"></vue-timepicker>
                            </div>
                            <div class="time_ondo_box">
                                <p class="time_ondo_tit">温度</p>
                                <textarea class="textarea_ondo" placeholder="00.0" v-model="senserInputDataTemperature" maxlength="5"></textarea>
                            </div>
                        </div>
                        <div class="time_now">現在の時刻：{{nowTimeStr}}</div>
                    </div>
                    <div class="btn_submit letter_spa">
                        <a role="button" @click.prevent.stop="inputSenserData(0,'input')">決定</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent3">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit_s">{{upperButtonName}}</p>
                            <p class="modal_header_tit">{{lowerButtonName}}</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>{{upperButtonName}} {{lowerButtonName}}<br>
                            の登録が完了しました。</p>
                        <snap v-if="temperatureLimitErrorExistFlg" class="red">逸脱したものが{{temperatureLimitErrorCount}}個あります。<br>再計測してください。</snap><br>
                        ※未入力がある場合は、再度入力してください。
                    </div>

                    <div class="btn_submit_box">
                        <div class="btn_submit" v-if="!reInputFlg && temperatureLimitErrorExistFlg">
                            <a role="button" @click.prevent.stop="remeasure">再計測に移動</a>
                        </div>
                        <div class="btn_submit2" v-if="reInputFlg && !temperatureLimitErrorExistFlg">
                          <a role="button" @click.prevent.stop="measure">計測に移動</a>
                        </div>
                        <div class="btn_submit2" v-if="(!reInputFlg && !temperatureLimitErrorExistFlg) || reInputFlg && temperatureLimitErrorExistFlg">
                            <a role="button" @click.prevent.stop="closeModal">閉じる</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent5">
          <div>
            <div class="modal_box wd512">
              <div class="modal_header_unit">
                <div class="modal_header_box">
                  <p class="modal_header_tit">入力チェックエラー</p>
                </div>
              </div>
              <div class="modal_content_tex">
                <p>未入力の項目があります。</p>
                <label class="text_white_space_pre_wrap" style="overflow-y: auto;width: 100%;max-height: 200px">{{nullCheckErrorMessage}}</label>
              </div>

              <div class="btn_submit_box">
                <div class="btn_submit2">
                  <a role="button" @click.prevent.stop="closeNullCheckModal">閉じる</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
    </div>
</template>

<script>

    import VueTimepicker from 'vue2-timepicker'
    import 'vue2-timepicker/dist/VueTimepicker.css'
    import PulseLoader from '@/app/components/PulseLoader.vue'
    import Message from '@/app/components/Message.vue'
    import PDF from 'pdfjs-dist'
    import PDFJSWorker from '!!file-loader!pdfjs-dist/build/pdf.worker.min.js';
    PDF.GlobalWorkerOptions.workerSrc = PDFJSWorker;

    export default {
        name: 'CookingCheck',
        components: {
            VueTimepicker,
            PulseLoader,
            Message
        },
        props:{
            lowerButtonName: {
                type: String,
                require: true
            },
            upperButtonName: {
                type: String,
                require: true
            },
            brandPath: {
                type: String,
                require: true
            },
            menuId: {
                type: Number,
                require: true,
            },
            subMenuId: {
                type: Number,
                require: true
            },
            reInputFlg: {
                type: Number,
                require: true,
                default: 0,
            },
            reCheckInputArray: {
              type: Array,
              require: true,
              default: () => [],
            }
        },
        data: function () {
            return {
                pages: 0,
                fileFormat:"",
                isLoading: false,
                isInitLoading:true,
                staffData:this.$store.getters['staff/data'],
                format:{
                    input:["L","hh:ss"],
                    data:["L","hh:ss"]
                },
                senserSelectData:{itemId:'',indexCount:null,headerId:null},  //温度選択対象データ
                senserInputDataMeasurementtime: '', // ここはオブジェクトにしてはいけない
                senserInputDataTemperature:'',
                getSenserIdListData:null,
                getSenserData:[{detectionDatetime:'',temperature:null,humidity:null}],   //選択したセンサーの履歴
                selectSendSenserId:'',
                nowTimeStr:null,
                page: 1, //現在のページ番号
                perPage: 10, //1ページ毎の表示件数
                totalPage: 20,
                time:5,
                timer:false,
                modal_title:'',
                list:[{indexLng:0,
                    cookingId:"",
                    tyori:"",
                    comment:"",
                    todayInputFlg:"",
                    allCheckFlg:"",
                    cencer:"",
                    selectedSensorId:"",
                    historyFlg:"",
                    histryData:[{cookingcheckitemid:null,cookingCheckHeaderId:null,cookingCheckHeaderNo:null,dayStatus:null,defStatus:null,result_value:null,input_type:null,manual_flg:null}],
                    groupName:"",
                    heatedUpperTemperature:null,
                    heatedLowerTemperature:null,
                    reHeatedUpperTemperature:null,
                    reHeatedLowerTemperature:null,
                }],
                hedderUpname1:"",
                hedderUpname2:"",
                hedderUpname3:"",
                hedderUpname4:"",
                hedderList1:"1",
                hedderList2:"1",
                hedderList3:"1",
                hedderList4:"1",
                showContent:false,
                showContent2:false,
                showContent3:false,
                showContent4:false,
                showContent5:false,
                rowspan:0,
                modal_image_file_path:'',
                image_file_str:null,
                validationMessage:'',
                validationModelMessage:'',
                alertMessage:'入力エラーがあります。',
                cookingColorDisabled:'cooking_background-color_disabled',
                cookingColorNoInput:'cooking_background-color_no-input',
                cookingColorInput:'cooking_background-color_input',
                cookingColorNotEditable:'cooking_background-color_not_editable',
                "dailyCheckMenuList": {
                    "cookingCheckButtonId": null,
                    "cookingCheckPageId": null,
                    "manualFilePath": "",
                    "informationFilePath": "",
                    "cookingHeaderList": [
                        {
                            "cookingCheckHeaderId": null,
                            "cookingCheckHeaderNo": null,
                            "upperHeaderName": "",
                            "lowerHeaderName": "",
                            "displayFlg": null,
                            "inputType": null,
                        }
                    ],
                    "cookingList": [
                        {
                            "cookingId": null,
                            "cookingName": "",
                            "cookingNameNo": null,
                            "historyFlg":null,
                            "cookingCheckItem":null,
                            "groupName":null,
                        }

                    ],
                    "sensorList": [
                        {
                            "sensorid": "",
                            "location": ""
                        }
                    ]
                },
                //重要管理項目チェック詳細取得(履歴の表示制御と調理名の入力制御)
                cooking: {
                    "cookingId": null,
                    "existHistory": null,
                    "checkedList": [
                        {
                            "cookingCheckItemId": null,
                            "cookingCheckHeaderId": null,
                            "inputFlg": null
                        }
                    ]
                },
                //計測結果履歴取得
                "sensorList": [
                    {
                        "sensorId": "",
                        "sensorHistoryList": [
                            {
                                "detectionDatetime": "",
                                "temperature": ""
                            }
                        ]
                    }
                ],
                modal_type : {
                    manual: "マニュアル",
                    info: "インフォメーション",
                },
                headerStyle: {
                    height: ""
                },
                boxStyle: {
                    height: ""
                },
              //重要管理項目チェック履歴取得(キー名重複のため名前変更)
              "cookingCheckHistory": [
                {
                  "cookingId": "",
                  "staffName": "",
                  "createdDatetime": "",
                  "checkedList": [
                    {
                      "cookingCheckItemId": null,
                      "status": null,
                      "resultValue": "",
                      "manualFlg": null,
                      inputType:null
                    }
                  ],
                  "comment": ""
                }
              ],
              searchWord:"",
              selectGroupWord:"",
              cookingNameGroup:[],
              isExitsGroup:false,
              selectFilterFlg:2,
              historyFilter:[
                {
                  "id":2,
                  "name":"全て"
                },
                {
                  "id": 1,
                  "name": "有り"
                },
                {
                  "id":0,
                  "name":"無し"
                }
              ],
              staffList: [],
              getStaffId:0,
              sensorAssignmentList:[],
              selectSensorIdList:[],
              selectRow:null,
              cookingCheckButtonNo:null,
              temperatureLimitErrorExistFlg: 0,
              temperatureLimitErrorCount:0,
              reCheckArray:[],
              nullCheckErrorFlg:false,
              nullCheckErrorMessage:'',
            }
        },
         updated() {
             this.allOkHeader()
        },
        computed:{
            headerFilter1:function(){
              if(this.rowspan == 2) {
                return this.dailyCheckMenuList.cookingHeaderList.filter(e => e.inputType !== 6 && e.displayFlg == 1 && (e.upperHeaderName !== '' && e.upperHeaderName !== null ))
              } else {
                return this.dailyCheckMenuList.cookingHeaderList.filter(e => e.inputType !== 6 && e.displayFlg == 1 )
              }
            },
            headerFilter2:function(){
                return this.dailyCheckMenuList.cookingHeaderList.filter(function (el) {
                    return el.displayFlg
                },this)
            },
            headerFilter3:function(){
              return this.dailyCheckMenuList.cookingHeaderList.filter(e => e.inputType !== 6 && e.displayFlg == 1 && (e.upperHeaderName === '' || e.upperHeaderName === null ))
            },
            filterItems() {
                var data = this.list;
                var filterWord = this.searchWord && this.searchWord.toLowerCase();
                if(filterWord){
                  data = data.filter(function (row){
                    return Object.keys(row).some(function (){
                      return String(row["cookingName"]).toLowerCase().includes(filterWord)
                    })
                  })
                }
                // グループフィルター
                if(this.selectGroupWord !== ""){
                  var filterGroupWord = this.selectGroupWord && this.selectGroupWord.toLowerCase();
                  if(filterGroupWord === '未グループ') {
                    data = data.filter(function (row){
                      return row["groupName"] == null;
                    })
                  } else {
                    data = data.filter(function (row){
                      return Object.keys(row).some(function (){
                        return String(row["groupName"]).toLowerCase().indexOf(filterGroupWord) === 0
                      })
                    })
                  }
                }
                // 履歴フィルター
                var flg = this.selectFilterFlg;
                if(flg != 2) {
                  data = data.filter(function (row) {
                    return row["historyFlg"] == flg;
                  })
                }

                if(this.reInputFlg && this.reCheckInputArray.length > 0) {
                  data = data.filter((row) => {
                    return this.reCheckInputArray.includes(row["cookingId"]);
                  })
                }
                return data;
            },
            getStaffName:function () {
                return  this.$store.getters['staff/name'];
            },
            disabledFlg() {
                return this.showContent || this.showContent2 || this.showContent3 || this.showContent4
            }
        },
        created: function(){
            this.calc();
        },
        methods: {
            onPageChange(page) {
                this.page = page;
            },
            async calc(){

                this.isInitLoading = true;
                var apiResponseFlg = true;
                this.getStaffId = this.$store.getters['staff/id'];

                //重要管理項目チェック内容取得
                var brandId = this.$store.getters['brand/id'];
                var storeId = this.$store.getters['store/data'].store_id;

                var cookingCheckButtonId = this.subMenuId
                var url = this.$apiEndpoint + 'user/brand/' + brandId + '/store/' + storeId + '/cooking_menu/' + cookingCheckButtonId ;

                await this.$axios
                    .get(url)
                    .then(response => {
                      this.dailyCheckMenuList = response.data;
                      this.cookingCheckButtonNo = response.data.cookingCheckButtonNo;
                      this.staffList = response.data.staffList;
                    })
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(()=> this.isInitLoading = false);

                // APIエラーの場青、処理終了
                if(!apiResponseFlg){
                    //処理終了
                    return null;
                }

                //ヘッダーの行列を設定する
                for( var T=0 ; T < this.dailyCheckMenuList.cookingHeaderList.length ; T++){

                    //列セルの結合数のチェック
                    if(this.dailyCheckMenuList.cookingHeaderList[T].upperHeaderName !== "" &&
                        this.dailyCheckMenuList.cookingHeaderList[T].upperHeaderName !== null){
                        this.rowspan = 2;
                        break;
                    }else{
                        this.rowspan = 1;
                    }
                }

                //カラムの結合処理
                var colspanInt = 0;
                var groupId = 1;
                var serchStr= '';
                for( var L=0 ; L < this.dailyCheckMenuList.cookingHeaderList.length ; L++){

                    var upperHdName = this.dailyCheckMenuList.cookingHeaderList[L].upperHeaderName;
                    if(serchStr !== upperHdName && this.dailyCheckMenuList.cookingHeaderList[L].displayFlg == 1){
                        var dddd = this.dailyCheckMenuList.cookingHeaderList.filter(e => e.upperHeaderName == upperHdName && e.displayFlg == 1 )
                        colspanInt = dddd.length;
                        switch (groupId) {
                            case 1:
                                this.hedderList1 = String(colspanInt);
                                this.hedderUpname1 = upperHdName;
                                serchStr = upperHdName;
                                groupId = groupId +1 ;
                                break;
                            case 2:
                                this.hedderList2 = String(colspanInt);
                                this.hedderUpname2 = upperHdName;
                                serchStr = upperHdName;
                                groupId = groupId +1 ;
                                break;
                            case 3:
                                this.hedderList3 = String(colspanInt);
                                this.hedderUpname3 = upperHdName;
                                serchStr = upperHdName;
                                groupId = groupId +1 ;
                                break;
                            case 4:
                                this.hedderList4 = String(colspanInt);
                                this.hedderUpname4 = upperHdName;
                                serchStr = upperHdName;
                                groupId = groupId +1 ;
                                break;
                        }
                    }
                }

                //画面の初期処理に呼び出す
                let itemList = [];
                // 履歴のデータにInputtypeを埋め込む
                var headerFilterAllData = this.headerFilterAll();
                var cookingCheckHistoryData = this.cookingCheckHistory

                // 履歴データの並び順で、ヘッダーのinputTypeを設定する
                for(var tyoriHistoryCount=0 ; tyoriHistoryCount < cookingCheckHistoryData.length ; tyoriHistoryCount++){

                  // 履歴内の1データ取得
                  var checkedListData =  cookingCheckHistoryData[tyoriHistoryCount].checkedList
                  for(var tyoriHistoryListCount=0 ; tyoriHistoryListCount < checkedListData.length ; tyoriHistoryListCount++){

                    // 履歴データのオブジェクト取得
                    var checkedListObj = checkedListData[tyoriHistoryListCount];
                    checkedListObj['inputType'] = headerFilterAllData[tyoriHistoryListCount].inputType;
                    this.cookingCheckHistory[tyoriHistoryCount].checkedList.splice(tyoriHistoryListCount,1,checkedListObj);
                  }
                }

                //ヘッダーのID設定を追加
                for(var k = 0 ; k < this.dailyCheckMenuList.cookingList.length ; k++){
                    if(this.dailyCheckMenuList.cookingList[k].groupName !== "" && this.dailyCheckMenuList.cookingList[k].groupName != null && !this.cookingNameGroup.some( group => group.groupName === this.dailyCheckMenuList.cookingList[k].groupName)) {
                      var group = new Object();
                      group['id'] = k;
                      group['groupName'] = this.dailyCheckMenuList.cookingList[k].groupName;
                      this.cookingNameGroup.push(group);
                    }

                    var indexList = new Object();
                    var inpuotApiData = [];

                    for( var i=0 ; i < this.dailyCheckMenuList.cookingHeaderList.length ; i++){
                        var inpuotApiDataObj = new Object();
                        if(this.dailyCheckMenuList.cookingHeaderList[i].displayFlg){

                          for(var diteleCount= 0 ; diteleCount < this.dailyCheckMenuList.cookingList[k].cookingCheckItem.length ; diteleCount++ ) {

                            if (this.dailyCheckMenuList.cookingHeaderList[i].cookingCheckHeaderId == this.dailyCheckMenuList.cookingList[k].cookingCheckItem[diteleCount].cookingCheckHeaderId) {
                              inpuotApiDataObj['cookingCheckHeaderId'] = this.dailyCheckMenuList.cookingHeaderList[i].cookingCheckHeaderId;
                              inpuotApiDataObj['cookingCheckHeaderNo'] = this.dailyCheckMenuList.cookingHeaderList[i].cookingCheckHeaderNo;
                              inpuotApiDataObj['status'] = null;
                              inpuotApiDataObj['result_value'] = '';

                              inpuotApiDataObj['dayStatus'] = null;
                              inpuotApiDataObj["cookingcheckitemid"] = this.dailyCheckMenuList.cookingList[k].cookingCheckItem[diteleCount].cookingCheckItemId;
                              inpuotApiDataObj['input_type'] = this.dailyCheckMenuList.cookingHeaderList[i].inputType;
                              inpuotApiDataObj['manual_flg'] = null;


                              var indexHdId = "hd_" + this.dailyCheckMenuList.cookingHeaderList[i].cookingCheckHeaderId;
                              var indexHdId2 = "htsi_" + this.dailyCheckMenuList.cookingList[k].cookingCheckItem[diteleCount].cookingCheckHeaderId;
                              indexList[indexHdId] = "";
                              indexList[indexHdId2] = this.dailyCheckMenuList.cookingList[k].cookingCheckItem[diteleCount].inputFlg;
                              if (this.dailyCheckMenuList.cookingList[k].cookingCheckItem[diteleCount].inputFlg == 1) {
                                inpuotApiDataObj['defStatus'] = 1;
                              } else if(this.dailyCheckMenuList.cookingList[k].cookingCheckItem[diteleCount].inputFlg == 2){
                                inpuotApiDataObj['defStatus'] = 2;
                              } else {
                                inpuotApiDataObj['defStatus'] = 3;
                              }
                            }
                          }
                          inpuotApiData.push(inpuotApiDataObj);
                        }

                    }

                    indexList["cookingId"] = this.dailyCheckMenuList.cookingList[k].cookingId;
                    indexList["cookingNameNo"] = null;
                    indexList["tyori"] = "";
                    indexList["cookingName"] = this.dailyCheckMenuList.cookingList[k].cookingName;
                    indexList["cookingNo"] = "";
                    indexList["comment"] = "";
                    indexList["todayInputFlg"] = "";

                    indexList["cencer"] = "";
                    indexList["selectedSensorId"] = "";
                    var sensorList = this.dailyCheckMenuList.sensorList;
                    if(this.dailyCheckMenuList.cookingList[k].sensorSetting.length > 0){
                      var ids = this.dailyCheckMenuList.cookingList[k].sensorSetting.map(item => item.id);
                      sensorList = this.dailyCheckMenuList.sensorList.filter(e => ids.includes(e.fkSensorId));
                    }
                    this.sensorAssignmentList.push(sensorList);
                    indexList["historyFlg"] = this.dailyCheckMenuList.cookingList[k].historyFlg;
                    indexList["indexLng"] = k;
                    indexList["histryData"] = inpuotApiData;
                    indexList["allCheckFlg"] = this.updateAllCheckFlg(indexList);
                    indexList["groupName"] = this.dailyCheckMenuList.cookingList[k].groupName;
                    indexList["heatedUpperTemperature"] = this.dailyCheckMenuList.cookingList[k].heatedUpperTemperature;
                    indexList["heatedLowerTemperature"] = this.dailyCheckMenuList.cookingList[k].heatedLowerTemperature;
                    indexList["reHeatedUpperTemperature"] = this.dailyCheckMenuList.cookingList[k].reHeatedUpperTemperature;
                    indexList["reHeatedLowerTemperature"] = this.dailyCheckMenuList.cookingList[k].reHeatedLowerTemperature;
                    itemList.push(indexList);
                }
                if(this.cookingNameGroup.length > 0){
                  this.isExitsGroup = true;
                  if(!this.cookingNameGroup.some( group => group.groupName === '未グループ')){
                    var noGroup = new Object();
                    noGroup['id'] = 0;
                    noGroup['groupName'] = '未グループ';
                    this.cookingNameGroup.unshift(noGroup);
                  }
                }
                this.list = itemList;
            },
            //〇×ボタン押下時のlist書き換え用メソッド
            clickCheck:function (event,itemId,indexCOunt,cookingCheckHeaderId) {

                //ボタン押下時のクリック制御
                var buttonCheckList = this.list[indexCOunt];

                //すべて〇チェックの場合は制御なし
                if(buttonCheckList.allCheckFlg === "1"){
                    return;
                }

                if(buttonCheckList[itemId] != 2){
                    var inCount = Number(buttonCheckList[itemId]);
                    buttonCheckList[itemId] = inCount + 1;
                    buttonCheckList = this.makeData(buttonCheckList,cookingCheckHeaderId,itemId);
                }
                else{
                    buttonCheckList[itemId] = "";
                    buttonCheckList = this.makeData(buttonCheckList,cookingCheckHeaderId,itemId);
                }

                this.list.splice(indexCOunt,1,buttonCheckList);
            },

            //すべて〇チェック時
            clickAllCheck:function (indexCount) {
                let list = this.list[indexCount];
                let headerList = this.inputTypeFilter(list, 4);
                this.allCheck(indexCount, headerList);

            },
            //すべて〇チェック処理
            allCheck:function (indexCount, headerList){
                let headerId = "";
                if (this.list[indexCount].allCheckFlg === "0") {
                    headerId = "1";
                    this.list[indexCount].allCheckFlg = "1";
                } else {
                    this.list[indexCount].allCheckFlg = "0";
                }

                let buttonList = this.list[indexCount];
                headerList.forEach(item => {
                    if(buttonList['htsi_'+item.cookingCheckHeaderId] === 1 || buttonList['htsi_'+item.cookingCheckHeaderId] === 2) {
                        buttonList['hd_' + item.cookingCheckHeaderId] = headerId;
                        let makeButtonList = this.makeData(buttonList, item.cookingCheckHeaderId, 'hd_' + item.cookingCheckHeaderId);
                        this.list.splice(indexCount, 1, makeButtonList);
                    }
                });
            },
            //コメント入力時の入力操作
            commnetInput:function (event,indexCOunt){
                var oooo = event.target.value;
                var commnetList = this.list[indexCOunt];
                commnetList["comment"] = oooo;
                //配列に反映
                this.list.splice(indexCOunt,1,commnetList);
            },
            //テキストボックス入力時の入力操作
            textBoxInput:function (event,indexCOunt,id,hederId){
                var textValue = event.target.value;
                var commnetList = this.list[indexCOunt];

                for(var Count= 0 ; Count < commnetList.histryData.length ; Count++ ){
                    if(commnetList.histryData[Count].cookingCheckHeaderId == hederId){
                        var histryDataOnList = commnetList.histryData[Count];
                        histryDataOnList['result_value'] = textValue;
                        commnetList.histryData.splice(Count,1,histryDataOnList)
                    }
                }
                commnetList[id] = textValue;
                //配列に反映
                this.list.splice(indexCOunt,1,commnetList);
            },
            //当日調理無のボタン押下時の入力操作
            todayCheckInput:function (indexCOunt,hederId) {
                var commnetList = this.list[indexCOunt];

                // 当日チェックがOFFの場合
                if(commnetList["todayInputFlg"] != 1){
                    commnetList["todayInputFlg"] =  1;

                    // 内部データの書き換えの繰り返し
                    for(var onCoint= 0 ; onCoint < commnetList.histryData.length ; onCoint++ ){

                        var histryDataOnList = commnetList.histryData[onCoint];
                        // 当日チェック チェック内容反映
                        if(commnetList.histryData[onCoint].cookingCheckHeaderId == hederId){
                            histryDataOnList['result_value'] = 1;
                        }

                        // ヘッダーNO 2-7は当日フラグ対象として除去
                        if([2,3,4,5,6,7].includes(commnetList.histryData[onCoint].cookingCheckHeaderNo)){
                            // 入力表示用フラグ初期化
                            commnetList["hd_" + commnetList.histryData[onCoint].cookingCheckHeaderId] = '';
                            commnetList["htsi_" + commnetList.histryData[onCoint].cookingCheckHeaderId] = '';

                            histryDataOnList['dayStatus'] = 2;
                            histryDataOnList['result_value'] = '';
                            //commnetList.histryData.splice(onCoint,1,histryDataOnList);
                        }
                    }
                }
                // 当日チェックがONの場合
                else{
                    commnetList["todayInputFlg"] = "";
                    // 入力制御用としてAPIデータを繰り返し

                    for(var i=0; i < this.cooking.checkedList.length ; i++) {
                        // 内部データの書き換えの繰り返し
                        for (var dwCount = 0; dwCount < commnetList.histryData.length; dwCount++) {

                            var histryDataOffList = commnetList.histryData[dwCount];

                            // 当日チェック チェック内容反映
                            if(commnetList.histryData[dwCount].cookingCheckHeaderId == hederId){
                                histryDataOffList['result_value'] = 0;
                            }

                            //  ヘッダーNO 2-7に初期値を設定
                            if (this.cooking.checkedList[i].cookingCheckHeaderId == commnetList.histryData[dwCount].cookingCheckHeaderId) {
                                // ヘッダーNO 2-7は当日フラグ対象として初期化
                                if ([2, 3, 4, 5, 6, 7].includes(commnetList.histryData[dwCount].cookingCheckHeaderNo)) {
                                    // ヘッダーのInputフラグ判定
                                    if (this.cooking.checkedList[i].inputFlg == 1 || this.cooking.checkedList[i].inputFlg == 2) {
                                        commnetList["htsi_" + this.cooking.checkedList[i].cookingCheckHeaderId] = this.cooking.checkedList[i].inputFlg;
                                        histryDataOffList['dayStatus'] = null;
                                        histryDataOffList['result_value'] = '';
                                    } else {
                                        commnetList["htsi_" + this.cooking.checkedList[i].cookingCheckHeaderId] = "";
                                        histryDataOffList['dayStatus'] = null;
                                        histryDataOffList['result_value'] = '';
                                    }
                                }
                            }
                        }
                    }

                }

                //配列に反映
                this.list.splice(indexCOunt,1,commnetList)
                let beforeAllCheckFlg =this.list[indexCOunt].allCheckFlg;
                let allCheckFlg = this.updateAllCheckFlg(this.list[indexCOunt]);

                this.list[indexCOunt].allCheckFlg = allCheckFlg;

                //すべて〇がチェックされている場合、一旦戻して再チェック
                if(beforeAllCheckFlg === '1' && allCheckFlg === '0'){
                    this.clickAllCheck(indexCOunt);
                }
            },
            updateAllCheckFlg:function(list){

                //入力タイプが〇×かつ有効なヘッダーを取得する
                let headerList = this.inputTypeFilter(list, 4);

                //〇×のヘッダーがなければすべて〇を非表示
                if(headerList.length < 1){
                    return "";
                }

                //入力可能な項目がなければ、すべて〇を非活性にする
                let result = '2';
                headerList.forEach(item => {
                    if(list['htsi_'+item.cookingCheckHeaderId] === 1 || list['htsi_'+item.cookingCheckHeaderId] === 2) {
                        //入力可能な項目があれば、すべて〇を活性にする
                        result = '0';
                    }
                });

                return result;
            },
            //機器選択ダイアログのボタン押下時の入力操作
            cencerSelect:function (event,indexCOunt,hederId) {

                var textValue = event.target.value;
                var sensor = this.sensorAssignmentList[indexCOunt].find(e => e.sensorId == textValue)

                var location = sensor?.location ?? '';
                var commnetList = this.list[indexCOunt];

                for(var Count= 0 ; Count < commnetList.histryData.length ; Count++ ){
                    if(commnetList.histryData[Count].cookingCheckHeaderId == hederId){
                        var histryDataOnList = commnetList.histryData[Count];
                        histryDataOnList['result_value'] = location;
                        commnetList.histryData.splice(Count,1,histryDataOnList)
                    }
                }

                //配列に反映
                this.list.splice(indexCOunt,1,commnetList);

            },
            //履歴ボタン押下時の操作
            clickCookingHistory:function(indexCOunt){
                var cookingId = this.list[indexCOunt].cookingId;
                this.$router.push({name: 'cookingcommnhistoryindex', params: {subMenuId:this.subMenuId,saikeisokuFlg:this.reInputFlg,cookingId:cookingId}});

            },
            //更新処理
            async sendCheckInput(){

                this.isLoading = true;

                //バリデーションフラグ
                var validationFlg = true;
                //バリデーションチェック(桁数)
                this.validationMessage = '';

                var apiResponseFlg = true;
                this.nullCheckErrorMessage = '';
                this.nullCheckErrorFlg = false;
                for(var checkCount = 0 ; checkCount < this.list.length ; checkCount++){
                    if(String(this.list[checkCount].comment).length > 200){
                        this.validationMessage="コメントは200桁以内で入力してください。"
                        this.scrollTop();
                        validationFlg = false;
                        break;
                    }

                    //未チェックの項目数
                    var valueNullCount = 0;
                    //1件でも入力があるかどうか
                    var isCheck = false;
                    var unCheckItemName = [];
                    for (var hCount = 0; hCount < this.list[checkCount].histryData.length; hCount++){
                        if(String(this.list[checkCount].histryData[hCount]['result_value']).length > 30){
                            this.validationMessage="チェック結果は30桁以内で入力してください"
                            this.scrollTop();
                            validationFlg = false;
                            break;
                        }
                        // input_type = 6 or dayStatus = 2 or defStatus = 3はチェックしなくてよい
                        if(this.list[checkCount].histryData[hCount]['input_type'] != 6 && this.list[checkCount].histryData[hCount]['dayStatus'] != 2 && this.list[checkCount].histryData[hCount]['defStatus'] != 3){
                          if(this.list[checkCount].histryData[hCount].result_value !== null && this.list[checkCount].histryData[hCount].result_value !== ''){
                            isCheck = true;
                          }
                        }
                        // 入力必須チェック（全項目必須もしくは全項目空白のみ許可）
                        // input_type = 6 or dayStatus = 2 or defStatus = 2 or defStatus = 3はチェックしなくてよい
                        if(this.list[checkCount].histryData[hCount]['input_type'] != 6 && this.list[checkCount].histryData[hCount]['dayStatus'] != 2 && this.list[checkCount].histryData[hCount]['defStatus'] === 1){
                          if(this.list[checkCount].histryData[hCount].result_value === null || this.list[checkCount].histryData[hCount].result_value === ''){
                            valueNullCount += 1;
                            var headerName = this.dailyCheckMenuList.cookingHeaderList.find(e => e.cookingCheckHeaderId ==  this.list[checkCount].histryData[hCount].cookingCheckHeaderId)
                            if(headerName != undefined){
                              var name = "";
                              if(headerName.upperHeaderName == null) {
                                name = headerName.lowerHeaderName;
                              } else {
                                name = headerName.upperHeaderName+"・"+headerName.lowerHeaderName;
                              }
                              unCheckItemName.push(name)
                            }
                          }
                        }

                    }

                    if(isCheck && valueNullCount > 0){
                      const joinName = unCheckItemName.join(',');
                      this.nullCheckErrorMessage += this.list[checkCount].cookingName + ' は ' + valueNullCount +'項目 【'+joinName+'】\n';
                      this.nullCheckErrorFlg = true;
                    }
                }
                if(this.nullCheckErrorFlg) {
                  this.showContent5 = true;
                  validationFlg = false;
                }
                if(!validationFlg){
                    this.isLoading = false;
                    //処理終了
                    return null;
                }

                //重要管理項目チェック内容取得API呼び出し
                var brandId = this.$store.getters['brand/id'];
                var storeId = this.$store.getters['store/data'].store_id;
                var url = this.$apiEndpoint + 'user/brand/' + brandId + '/store/' + storeId + '/cooking_check/update' ;
                this.temperatureLimitErrorExistFlg = 0;
                this.temperatureLimitErrorCount = 0;
                this.reCheckArray = [];
                for(var k =0 ; k < this.list.length ; k++){

                    var sendFlg = false;

                    //送信可能かをチェックする
                    if(this.list[k].cookingId === '' || this.list[k].cookingId === null){
                        //次のデータを処理
                        continue;
                    }
                    if(!sendFlg){
                        for(var sendCheckCount = 0 ; sendCheckCount < this.list[k].histryData.length ; sendCheckCount++){
                            if(this.list[k].histryData[sendCheckCount].dayStatus !== null && this.list[k].histryData[sendCheckCount].dayStatus !== ''){
                                sendFlg = true;
                            }
                            else if(this.list[k].histryData[sendCheckCount].result_value !== null && this.list[k].histryData[sendCheckCount].result_value !== ''){
                                sendFlg = true;
                            }
                        }
                        if(this.list[k].comment !== ''){
                            sendFlg = true;
                        }
                    }

                    if(sendFlg){

                        var cookingid = this.list[k].cookingId;
                        var coment = this.list[k].comment;
                        var staffId = this.$store.getters['staff/staffId']

                        var cookingCheckHistory = [];
                        //送信データの成形
                        for(var sendCount = 0 ; sendCount < this.list[k].histryData.length ; sendCount++){
                            var cookingHistoryObj = new Object();
                            cookingHistoryObj['cooking_check_item_id'] = this.list[k].histryData[sendCount].cookingcheckitemid
                            // 当日チェックを判定
                            if(this.list[k].histryData[sendCount].dayStatus == 2){
                                cookingHistoryObj['status'] = this.list[k].histryData[sendCount].dayStatus
                            }
                            // 入力不要の判定
                            else if(this.list[k].histryData[sendCount].defStatus == 3){
                                cookingHistoryObj['status'] = this.list[k].histryData[sendCount].defStatus
                            }
                            // 任意項目の判定
                            else if(this.list[k].histryData[sendCount].defStatus == 2){
                              cookingHistoryObj['status'] = 4;
                            }
                            else {
                                cookingHistoryObj['status'] = 1;
                            }
                            cookingHistoryObj['result_value'] = this.list[k].histryData[sendCount].result_value
                            cookingHistoryObj['input_type'] = this.list[k].histryData[sendCount].input_type
                            cookingHistoryObj['manual_flg'] = this.list[k].histryData[sendCount].manual_flg
                          var temperatureCheckFlg = 0;
                          if((this.cookingCheckButtonNo == 1 || this.cookingCheckButtonNo == 2) && this.list[k].heatedUpperTemperature != null && this.list[k].heatedLowerTemperature != null) {
                            //303132
                            if(this.list[k].histryData[sendCount].cookingCheckHeaderNo == 30 || this.list[k].histryData[sendCount].cookingCheckHeaderNo == 31 || this.list[k].histryData[sendCount].cookingCheckHeaderNo == 32){
                              temperatureCheckFlg = this.limitCheckTemperature(cookingHistoryObj['result_value'], this.list[k].heatedUpperTemperature, this.list[k].heatedLowerTemperature);
                              if(temperatureCheckFlg) {
                                this.temperatureLimitErrorExistFlg = 1;
                                this.temperatureLimitErrorCount += 1;
                                this.validationMessage += this.list[k].cookingName + 'は、再計測を実施してください！\n';
                                this.reCheckArray.push(this.list[k].cookingId);
                              }
                            }
                          } else if(this.cookingCheckButtonNo == 3 && this.list[k].heatedUpperTemperature != null && this.list[k].heatedLowerTemperature != null) {
                              //567
                              if(this.list[k].histryData[sendCount].cookingCheckHeaderNo == 5 || this.list[k].histryData[sendCount].cookingCheckHeaderNo == 6 || this.list[k].histryData[sendCount].cookingCheckHeaderNo == 7){
                                  temperatureCheckFlg = this.limitCheckTemperature(cookingHistoryObj['result_value'], this.list[k].heatedUpperTemperature, this.list[k].heatedLowerTemperature);
                                  if(temperatureCheckFlg) {
                                      this.temperatureLimitErrorExistFlg = 1;
                                      this.temperatureLimitErrorCount += 1;
                                      this.validationMessage += this.list[k].cookingName + 'は、再計測を実施してください！\n';
                                      this.reCheckArray.push(this.list[k].cookingId);
                                  }
                              }
                          } else if(this.cookingCheckButtonNo == 4 && this.list[k].heatedUpperTemperature != null && this.list[k].heatedLowerTemperature != null) {
                              //345
                              if(this.list[k].histryData[sendCount].cookingCheckHeaderNo == 3 || this.list[k].histryData[sendCount].cookingCheckHeaderNo == 4 || this.list[k].histryData[sendCount].cookingCheckHeaderNo == 5){
                                  temperatureCheckFlg = this.limitCheckTemperature(cookingHistoryObj['result_value'], this.list[k].heatedUpperTemperature, this.list[k].heatedLowerTemperature);
                                  if(temperatureCheckFlg) {
                                      this.temperatureLimitErrorExistFlg = 1;
                                      this.temperatureLimitErrorCount += 1;
                                      this.validationMessage += this.list[k].cookingName + 'は、再計測を実施してください！\n';
                                      this.reCheckArray.push(this.list[k].cookingId);
                                  }
                              }
                          } else if(this.cookingCheckButtonNo == 5 && this.list[k].heatedUpperTemperature != null && this.list[k].heatedLowerTemperature != null) {
                              //345,9

                              if(this.list[k].histryData[sendCount].cookingCheckHeaderNo == 3 || this.list[k].histryData[sendCount].cookingCheckHeaderNo == 4 || this.list[k].histryData[sendCount].cookingCheckHeaderNo == 5){
                                  temperatureCheckFlg = this.limitCheckTemperature(cookingHistoryObj['result_value'], this.list[k].heatedUpperTemperature, this.list[k].heatedLowerTemperature);
                                  if(temperatureCheckFlg) {
                                      this.temperatureLimitErrorExistFlg = 1;
                                      this.temperatureLimitErrorCount += 1;
                                      this.validationMessage += this.list[k].cookingName + 'は、再計測を実施してください！\n';
                                      this.reCheckArray.push(this.list[k].cookingId);
                                  }
                              }
                              if(this.list[k].histryData[sendCount].cookingCheckHeaderNo == 9){
                                  temperatureCheckFlg = this.limitCheckTemperature(cookingHistoryObj['result_value'], this.list[k].reHeatedUpperTemperature, this.list[k].reHeatedLowerTemperature);
                                  if(temperatureCheckFlg) {
                                      this.temperatureLimitErrorExistFlg = 1;
                                      this.temperatureLimitErrorCount += 1;
                                      this.validationMessage += this.list[k].cookingName + 'は、再計測を実施してください！\n';
                                      this.reCheckArray.push(this.list[k].cookingId);
                                  }
                              }
                          }
                          if(this.list[k].histryData[sendCount].cookingCheckHeaderNo )
                            cookingCheckHistory.push(cookingHistoryObj);
                        }
                        const uniqueMessage = [...new Set(this.validationMessage.split('\n'))];
                        this.validationMessage = uniqueMessage.join('\n');
                        var staff = this.staffList.find((e) => e.id === this.getStaffId);
                        //更新API呼び出し
                        await this.$axios
                            .post(url, {cooking_id:cookingid,staff_id:staffId,staff_name:staff.staffName,remeasure_flg:this.reInputFlg,
                                cookingCheckHistory:cookingCheckHistory,comment:coment})
                            .then()
                            .catch((err) => {
                                let error = {
                                    button: {
                                        path: {name: 'top', params:{brandPath: this.brandPath}}
                                    }}
                                apiResponseFlg = false;
                                this.isLoading = false;
                                if (err.customError) {
                                    error = Object.assign(error, err.customError);

                                    if(error.code == 400){
                                        this.validationMessage =  error.message;
                                        this.scrollTop();
                                    }
                                }
                                if(error.code !== 400){
                                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                                }
                            });
                        if(!apiResponseFlg){
                            break;
                        }
                    }
                }
                // 処理エラーがない場合
                if(apiResponseFlg){
                    this.isLoading = false;
                    this.showContent3 = true;
                }
            },
            async onSelectChange(event,key){

                var senserId = ''
                if(key == 'Load'){
                    senserId = event.target.value;
                }
                else{
                    senserId = this.selectSendSenserId
                }
                this.getSenserDataFromAWS(senserId)
            },
            async getSenserDataFromAWS(senserId) {

                this.isLoading = true;

                //重要管理項目チェック内容取得
                var brandId = this.$store.getters['brand/id'];
                var storeId = this.$store.getters['store/data'].store_id;
                var sensorKbn = 1;
                var sensorIdList = this.sensorAssignmentList[this.selectRow].map(e => e.sensorId);

                this.getSenserData = [{detectionDatetime:'',temperature:null,humidity:null}];

                var url = this.$apiEndpoint + 'user/brand/' + brandId + '/store/' + storeId + '/sensor/' + sensorKbn + '/history' ;

                await this.$axios
                    .post(url,{sensor_id_list: sensorIdList})
                    .then(response => (this.sensorList = response.data.sensorList))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(()=> this.isLoading = false);

                for(var i = 0 ; i < this.sensorList.length ; i++){
                    if(this.sensorList[i].sensorId  == senserId){
                        this.getSenserData = this.sensorList[i].sensorHistoryList
                        break;
                    }
                }

                this.selectSendSenserId = senserId;

            },
            inputSenserData(index,inputType){

                var lotMeasurementtime = '';
                var lotTemperature = '';
                var manualFlg = null;
                this.validationModelMessage = '';

                // 手入力時のみバリデーションチェックを実施
                if(inputType === 'input'){
                    // バリデーションチェック
                    if(this.senserInputDataMeasurementtime == '' || this.senserInputDataTemperature == '') {
                        this.validationModelMessage = '測定時刻または温度が未入力です。'
                        return ;
                    }
                    if(!this.checkTemperatureFormat(this.senserInputDataTemperature)) {
                        this.validationModelMessage="温度は数値で入力してください。"
                        return ;
                    }

                    // 桁数チェック
                    if(String(this.senserInputDataTemperature).length > 5 ){
                        this.validationModelMessage="温度は5桁以内で入力してください。"
                        return ;
                    }

                    // 小数点の形式チェック
                    if(this.senserInputDataTemperature.indexOf('.') !== -1){
                        var arrayInputDataTemperature  = this.senserInputDataTemperature.toString().split('.');
                        if(arrayInputDataTemperature[1].length > 1){
                            this.validationModelMessage="温度は、小数点第1位まで入力してください。";
                            return ;
                        }
                    }

                    // 温度 範囲チェック
                    if(this.senserInputDataTemperature  > 409.5){
                        this.validationModelMessage="温度は、409.5以下の数字を指定してください。";
                        return ;
                    }
                    else if(this.senserInputDataTemperature < -99.9){
                        this.validationModelMessage="温度は、-99.9以上の数字を指定してください。";
                        return ;
                    }
                }

                if(inputType == 'Auto'){
                    lotMeasurementtime = this.getSenserData[index].detectionDatetime;

                    // 自動取得の場合、時間を成形する
                    lotMeasurementtime = lotMeasurementtime.slice(11);
                    lotTemperature = this.getSenserData[index].temperature;

                    manualFlg = 0;
                }
                else{
                    lotMeasurementtime = this.senserInputDataMeasurementtime;
                    lotTemperature = this.senserInputDataTemperature;
                    manualFlg = 1;
                }

                var commnetList = this.list[this.senserSelectData['indexCount']];

                for(var Count= 0 ; Count < commnetList.histryData.length ; Count++ ){
                    if(commnetList.histryData[Count].cookingCheckHeaderId == this.senserSelectData.headerId){
                        var histryDataOnList = commnetList.histryData[Count];
                        histryDataOnList['result_value'] = lotMeasurementtime + '\r\n' + lotTemperature + '℃';
                        histryDataOnList['manual_flg'] = manualFlg;
                        commnetList.histryData.splice(Count,1,histryDataOnList)
                    }
                }

                //配列に反映
                this.list.splice(this.senserSelectData['indexCount'],1,commnetList);

                this.clearSensorTimePicker()
                this.senserInputDataTemperature = '';
                this.senserSelectData['itemId'] = '';
                this.senserSelectData['indexCount'] = null;
                this.senserSelectData['headerId'] = null;
                this.selectSendSenserId = '';

                if(inputType == 'Auto'){
                    this.showContent2 = false;
                }
                else{
                    this.showContent4 = false;
                }
            },
            openModel(value,fileStr) {

                // 拡張子の格納
                if(value !== null && value !== ""){
                    var length = value.length;
                    var searchStrStart = value.lastIndexOf(".",length) ;
                    var searchStrEnd = value.lastIndexOf("?",length) ;
                    var fileFormatStr = value.slice(searchStrStart,searchStrEnd)
                    this.fileFormat = fileFormatStr.replace("?","").replace(".","");
                }

                // PDFと画像の処理判定
                if(this.fileFormat == 'pdf'){
                    // PDF
                    let loadingTask = PDF.getDocument(value);
                    loadingTask.promise.then(pdf => {
                        this.pdfDoc = pdf;
                        this.pages = this.pdfDoc.numPages;
                        this.$nextTick(() => {
                            this.renderPage(1);
                        });
                    }).catch(() => {
                        let error = {
                            button: {
                                path: {name: 'top', params: {brandPath: this.brandPath}}
                            },
                            'message': 'PFDファイルの描画に失敗しました。'
                        };
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(() => this.isInitLoading = false);

                }
                else if(this.fileFormat !== ""){
                    // 画像表示時
                    this.modal_image_file_path = value;
                    this.fileFormat = "img";
                }
                else{
                    // ファイル未設定
                    this.modal_image_file_path = "";
                    this.fileFormat = "";
                }

                this.modal_title = fileStr;
                this.showContent = true;
            },
            renderPage (num) {
                this.pdfDoc.getPage(num).then(page => {
                    // 描画処理
                    let canvas = document.getElementById("canvas" + num);
                    let viewport = page.getViewport({ scale: 0.5, });
                    let desiredWidth = canvas.parentElement.clientWidth;
                    let scale = desiredWidth / viewport.width;
                    let scaledViewport = page.getViewport({ scale: scale, });

                    let ctx = canvas.getContext('2d');
                    canvas.height = scaledViewport.height;
                    canvas.width = scaledViewport.width;

                    let renderContext = {
                        canvasContext: ctx,
                        viewport: scaledViewport
                    };
                    //PDFに複数のページがある場合、複数回レンダリングする
                    page.render(renderContext);
                    if (this.pages > num) {
                        this.renderPage(num + 1);
                    }
                });
            },
            closeModel() {
                this.selectSendSenserId = "";
                this.showContent = false;
            },
            async openModel2(itemId,indexCount,cookingCheckHeaderId) {
                // メッセージ初期化
                this.validationModelMessage = '';

                //選択対象を格納
                this.senserSelectData['itemId'] = itemId;
                this.senserSelectData['indexCount'] = indexCount;
                this.senserSelectData['headerId'] = cookingCheckHeaderId;

                //現在時刻を設定
                let nowDate = new Date();
                let hours = ("0" + nowDate.getHours()).slice(-2);
                let minutes = ("0" + nowDate.getMinutes()).slice(-2);
                this.nowTimeStr = hours + ':' + minutes

                var commnetList = this.list[indexCount];
                if(commnetList.selectedSensorId !== '') {
                  this.selectSendSenserId = commnetList.selectedSensorId;
                }

                if(this.sensorAssignmentList[indexCount].length == 1) {
                  this.selectSendSenserId = this.sensorAssignmentList[indexCount][0].sensorId;
                }

                this.selectRow = indexCount;
                await this.getSenserDataFromAWS(this.selectSendSenserId);
                this.showContent2 = true;
            },
            closeModel2() {
                this.validationModelMessage = '';
                this.clearSensorTimePicker()
                this.senserInputDataTemperature = '';
                this.senserSelectData['itemId'] = '';
                this.senserSelectData['indexCount'] = null;
                this.senserSelectData['headerId'] = null;
                this.selectSendSenserId = '';
                this.showContent2 = false;
            },
            closeModel4() {
                this.validationModelMessage = '';
                this.clearSensorTimePicker()
                this.senserInputDataTemperature = '';
                this.senserSelectData['itemId'] = '';
                this.senserSelectData['indexCount'] = null;
                this.senserSelectData['headerId'] = null;
                this.selectSendSenserId = '';
                this.showContent4 = false;
            },
            closeModal(){
                if(this.temperatureLimitErrorExistFlg){
                  this.reCheckInputArray = [...new Set(this.reCheckArray)];
                }
                //TOPへ遷移
                clearInterval(this.timer);
                this.timer = 0;
                this.showContent3 = false;
                this.calc();
            },
            closeNullCheckModal(){
              //TOPへ遷移
              clearInterval(this.timer);
              this.timer = 0;
              this.showContent5 = false;
            },
            remeasure() {
                this.showContent3 = false
                const uniqueReCheckArray = [...new Set(this.reCheckArray)];
                clearInterval(this.timer)
                this.$router.push({ name: 'cookingCheckReInput' ,params: { menuId: this.menuId, subMenuId: this.subMenuId, brandPath: this.brandPath, reCheckInputArray:uniqueReCheckArray}})


            },
            measure() {
              this.showContent3 = false
              clearInterval(this.timer)
              this.$router.push({ name: 'cookingCheckInput' ,params: { menuId: this.menuId, subMenuId: this.subMenuId, brandPath: this.brandPath}})
            },
            manualChange(){
                this.showContent2 = false;
                this.showContent4 = true;

            },
            async autoChange(){
                await this.getSenserDataFromAWS(this.selectSendSenserId);
                this.showContent2 = true;
                this.showContent4 = false;
            },
            makeData(buttonCheckList,cookingCheckHeaderId,itemId){

                for(var Count= 0 ; Count < buttonCheckList.histryData.length ; Count++ ){
                    if(buttonCheckList.histryData[Count].cookingCheckHeaderId == cookingCheckHeaderId){
                        var histryDataOnList = buttonCheckList.histryData[Count];

                        if(buttonCheckList[itemId] == 1){
                            histryDataOnList['result_value'] = 1;
                            buttonCheckList.histryData.splice(Count,1,histryDataOnList);
                        }
                        else if(buttonCheckList[itemId] == 2){
                            histryDataOnList['result_value'] = 0;
                            buttonCheckList.histryData.splice(Count,1,histryDataOnList);
                        }
                        else{
                            histryDataOnList['result_value'] = '';
                            buttonCheckList.histryData.splice(Count,1,histryDataOnList);
                        }
                    }
                }
                return buttonCheckList;
            },
            startTimer:function(){
                this.time = 5;
                this.stopTImer();
                this.timer = setInterval(() => this.countdown(),1000);
            },
            //タイマー設定
            stopTImer:function(){
                if(this.timer){
                    clearInterval(this.timer);
                    this.timer = 0;
                }
            },
            countdown:function () {
                if(this.time > 0){
                    this.time--;
                }
                else{
                    clearInterval(this.timer);
                    this.timer = 0;
                    this.closeModal();
                }
            },
            destoryed(){
                this.stopTImer();
            },
            chengeClore:function (histryData,indexCount) {

              var ListLength = this.list.length;
              // 初期表示時(Listは1行の為デフォルトスタイルを返却)
              if (ListLength == 1) {
                return this.cookingColorInput;
              } else {
                var defStatus = histryData[indexCount].defStatus;
                var dayStatus = histryData[indexCount].dayStatus;
                if (dayStatus == 2) {
                  return this.cookingColorNoInput;
                } else if (defStatus == 3) {
                  return this.cookingColorDisabled;
                } else {
                  return this.cookingColorInput;
                }
              }
            },
            inputTypeResult(item,index){
                if(this.list.length == 0){
                    return false
                }
                else{
                    var resultValue =  item.histryData[index].result_value;
                    if(resultValue == '' || resultValue == null){
                        return false
                    }
                    else{
                        return true
                    }
                }
            },
            // 文字種チェック 時間
            checkTimeFormat: function (inputData) {
                const re = new RegExp(/^[0-9]{2}:[0-9]{2}$/);
                return re.test(inputData);
            },
            // 文字種チェック 温度
            checkTemperatureFormat: function (inputData) {
                // プレースホルダ通りの入力
                if (inputData === '00.0') {
                    return true
                }
                // 数値のみ受け付け
                const re = new RegExp(/^[-]?([1-9]\d*|0)(\.\d+)?$/)
                return re.test(inputData)
            },
            onCloseTimePicker: function (v, indexCount, index) {
                const replacedTime = this.replaceTime(v)
                if (replacedTime) {
                    this.filterItems[indexCount].histryData[index].result_value = replacedTime
                }
            },
            onOpenSensorTimePicker: function () {
                this.senserInputDataMeasurementtime = ''
            },
            onCloseSensorTimePicker: function () {
                const replacedTime = this.replaceTime(this.senserInputDataMeasurementtime)
                if (replacedTime) {
                    this.senserInputDataMeasurementtime = replacedTime
                }
            },
            replaceTime: function (v) {
                if (v === 'HH:mm') {
                    return
                }
                return v.replace(/HH|mm/, '00')
            },
            clearSensorTimePicker: function () {
                // pickerを空にするのにオブジェクトの代入が必要: ライブラリの仕様
                this.senserInputDataMeasurementtime = { HH: '', mm: '', ss: '' }
            },
            isStr: function (obj) {
                return typeof (obj) == 'string' || obj instanceof String
            },
            scrollTop() {
                window.scrollTo(0,0);
            },
            allOkHeader: function () {
                var headerHeight = this.$refs.tbody.clientHeight
                this.headerStyle.height = headerHeight + 'px'

                var boxHeight = document.getElementById('tdHeight').childNodes[0].clientHeight
                this.boxStyle.height = boxHeight + 'px'
            },
            inputTypeFilter: function (indexList, inputType) {

                //入力タイプが〇×のヘッダーを取得する
                let headerList = this.dailyCheckMenuList.cookingHeaderList.filter(item => item.inputType === inputType && item.displayFlg);

                //当日調理無がONの場合はチェック対象外を弾く
                if (indexList.todayInputFlg === 1) {
                    const todayNonCheckNo = [2, 3, 4, 5, 6, 7];
                    headerList = headerList.filter(item => { return !(todayNonCheckNo.includes(item.cookingCheckHeaderNo)) });
                }

                return headerList;
            },
            headerFilterAll:function(){
              return this.dailyCheckMenuList.cookingHeaderList.filter(e => e.displayFlg == 1 )
            },
            getTemperature:function(resultValue) {
              if(resultValue == ""){
                return null;
              }
              //℃
              const match = resultValue.match(/([+-]?\d+(?:\.\d+)?)(?=℃)/);
              return match ? parseFloat(match[1]): null;
            },
            limitCheckTemperature:function(value, upperTemperature, lowerTemperature) {
              const temperature = this.getTemperature(value);
              if(temperature == null) {
                return 0;
              }

              if(upperTemperature < temperature || lowerTemperature > temperature){
                return 1;
              }
            },

        }
    };
</script>